import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as analyticsAPI from 'api/Settings/index';
import { isEmpty } from 'utils/redux';

const initialState = {
  data: null,
  totalRecord: null,
  rangeDate: null,
  CardData: null,
  features_data: null,
  lowheader: null,
  highheader: null,
  highcomponent: null,
  lowcomponent: null,
  TabName: 'All',
  ui: {
    loading: false,
    msg: ''
  },
  status: ''
};
const getAnalyticState = (state) => state.reporting;

const getPersonal = createAsyncThunk('Personal/getPersonal', async (params) => {
  const res = await analyticsAPI.GetPersonalData(params);
  console.log('userpersonaldata', res.data?.data);
  return res.data?.data;
});
const updatePersonal = createAsyncThunk('Personal/updatePersonal', async (params) => {
  const res = await analyticsAPI.UpdatePersonalData(params);
  console.log('userpersonaldata', res.data?.data);
  return res.data?.data;
});
const SettingSlice = createSlice({
  name: 'Personal',
  initialState: initialState,

  reducers: {
    resetState: () => {
      return initialState;
    }
  },

  extraReducers: {
    [getPersonal.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getPersonal.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;

      if (isEmpty(action.payload)) {
        state.data = null;
      } else {
        state.data = action.payload;
      }
    },

    [getPersonal.rejected]: (state, action) => {
      console.log(action.error.message, 'action.error.message');
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [updatePersonal.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [updatePersonal.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;

      if (isEmpty(action.payload)) {
        state.data = null;
      } else {
        state.data = action.payload;
      }
    },

    [updatePersonal.rejected]: (state, action) => {
      console.log(action.error.message, 'action.error.message');
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }

    // getDownloadReport
  }
});

const { resetState } = SettingSlice.actions;

export default SettingSlice.reducer;

export { getPersonal, updatePersonal, getAnalyticState, resetState };
